import { PageRender } from "@/components/layout/frontend/page"

/**
 * Page: VPDays
 */
const VPDays: React.FC = () => {
  return <PageRender pageKey="vpDays" />
}
export default VPDays
